import {createSlice} from '@reduxjs/toolkit';
import { StepTitle } from 'semantic-ui-react';


const userStorage=()=>{
    if(localStorage.getItem('userOirsPena')!==null){
        return JSON.parse(localStorage.getItem('userOirsPena'));
    }else{
        return null;
    }
    
}

export const userSlice = createSlice({
    name:"user",
    initialState:{
        userStorage
    },
    reducers:{
        login: (state,action) => {
            state.user=action.payload;
            localStorage.setItem('userOirsPena', JSON.stringify(state));
        },
        logout:(state)=>{
            localStorage.removeItem('userOirsPena');
            state.user=null;
        }
     }
})

export const {login,logout} =userSlice.actions;
export const selectUser = (state)=> state.user.user;
export default userSlice.reducer;
